<template>
  <div class="d-column content">
    <div><bread-list></bread-list></div>
    <div class="d-flex">
      <div class="">
        <aside-list
          :asideTitle="asideTitle"
          :title="title"
          :asideList="asideList"
          :currNav="currNav"
          :routeKeepAlive="routeKeepAlive"
          :routeKeepChild="routeKeepChild"
          @changeBread="changeBread"
          @changeType="changeType"
          @listIndexChange="listIndexChange"
        ></aside-list>
      </div>
      <div class="" v-if="currType == 'list'">
        <aside-article-list
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
          :currPath="currPath"
          :listIndex="listIndex"
          :listChildIndex="listChildIndex"
          :resData="resData"
        ></aside-article-list>
      </div>
      <div class="" v-if="currType == 'article'">
        <aside-content
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
        ></aside-content>
      </div>
      <div class="" v-if="currType == 'table'">
        <aside-table
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
        ></aside-table>
      </div>
      <div class="" v-if="currType == 'image'">
        <aside-image
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
          :currPath="currPath"
          :listIndex="listIndex"
          :listChildIndex="listChildIndex"
        ></aside-image>
      </div>
      <div class="" v-if="currType == 'club'">
        <aside-club
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
          :currPath="currPath"
          :listIndex="listIndex"
          :listChildIndex="listChildIndex"
        ></aside-club>
      </div>
      <div class="" v-if="currType == 'team'">
        <aside-team
          :asideTitle="asideTitle"
          :title="title"
          :currPrograma="currPrograma"
          :currPath="currPath"
          :listIndex="listIndex"
          :listChildIndex="listChildIndex"
        ></aside-team>
      </div>
    </div>
  </div>
</template>
<script>
import AsideList from '../AsideList/index.vue'
import BreadList from '../BreadList/index.vue'
import AsideArticleList from '../AsideArticleList/index.vue'
import AsideContent from '../AsideContent/index.vue'
import AsideTable from '../AsideTable/index.vue'
import AsideImage from '../AsideImage/index.vue'
import AsideClub from '../AsideClub/index.vue'
import AsideTeam from '../AsideTeam/index.vue'
export default {
  name: 'SecondPage',
  props: [
    'asideTitle',
    'title',
    'currPrograma',
    'asideList',
    'currType',
    'currPath',
    'routeKeepAlive',
    'routeKeepChild',
    'resData',
  ],
  components: {
    AsideList,
    BreadList,
    AsideArticleList,
    AsideContent,
    AsideTable,
    AsideImage,
    AsideClub,
    AsideTeam,
  },
  data() {
    return {
      currNav: 0,
      listIndex: 0,
      listChildIndex: 0,
    }
  },
  created() {
    this.$emit('titleChange', this.asideList[0].title)
    if (this.asideList[0].child.length > 0) {
      this.$emit('currProgramaChange', this.asideList[0].child[0].title)
      this.$emit('currTypeChange', this.asideList[0].child[0].showType)
    } else {
      this.$emit('currProgramaChange', '')
      this.$emit('currTypeChange', this.asideList[0].showType)
    }
    this.currNav = this.$store.state.currNavNum
  },
  watch: {
    storeChange: {
      handler: function () {
        this.currNav = this.$store.state.currNavNum
      },
      deep: true,
    },
  },
  computed: {
    storeChange: function () {
      return this.$store.state.currNavNum
    },
  },
  methods: {
    changeBread(two, three) {
      this.$emit('titleChange', two)
      this.$emit('currProgramaChange', three)
    },
    changeType(type) {
      this.$emit('currTypeChange', type)
    },
    listIndexChange(val, child) {
      this.listIndex = val
      this.listChildIndex = child
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
</style>
